// Icon weights
var FAL = 'fal';
var FAS = 'fas';
var FAR = 'far';
// Light
export var FAL_LINK = [FAL, 'link'];
// Regular
export var FAR_BASKET_SHOPPING = [FAR, 'basket-shopping'];
export var FAR_CALCULATOR = [FAR, 'calculator'];
export var FAR_CALENDAR_DAY = [FAR, 'calendar-day'];
export var FAR_EARTH_AMERICA = [FAR, 'earth-america'];
export var FAR_FORK_KNIFE = [FAR, 'fork-knife'];
export var FAR_GAS_PUMP = [FAR, 'gas-pump'];
export var FAR_MAGNIFYING_GLASS = [FAR, 'magnifying-glass'];
export var FAR_MOBILE = [FAR, 'mobile'];
export var FAR_MONEY_BILLS = [FAR, 'money-bills'];
export var FAR_SEAT_AIRLINE = [FAR, 'seat-airline'];
export var FAR_SUITCASE = [FAR, 'suitcase'];
// Solid
export var FAS_LINK = [FAS, 'link'];
export var FAS_CARET_UP = [FAS, 'caret-up'];
export var FAS_CARET_DOWN = [FAS, 'caret-down'];
